import * as React from 'react';
import { gql } from '@apollo/client';
import { PublishingController } from './Publishing.controller';
import { useGetWorkspaceLazyQuery, useUpdateWorkspaceSettingsMutation } from '../../../models/graphql';

gql`
  query GetWorkspace($workspaceId: ID!) {
    workspace(workspaceId: $workspaceId) {
      id
      name
      settings {
        id
        evergreenRecycling
        attributionInstagram
        minimumRecycleTime
        multiMediaAttachMode
        defaultQueuePosition
        fbLinkPreview
        importMediaBehavior
      }
    }
  }

  mutation UpdateWorkspaceSettings($input: UpdateWorkspaceSettingsInput!, $workspaceId: ID!) {
    updateWorkspaceSettings(input: $input, workspaceId: $workspaceId) {
      workspace {
        id
        settings {
          id
          campaignTracking
          shouldRemoveUtm
          evergreenRecycling
          attributionInstagram
          minimumRecycleTime
          multiMediaAttachMode
          defaultQueuePosition
          fbLinkPreview
          importMediaBehavior
          defaultBitly {
            domain
            bitly {
              ...CoreBitlyFields
            }
          }
        }
      }
    }
  }
`;

export const PublishingApollo = (): JSX.Element => {
  const [getWorkspaceSettingsQuery, workspaceSettingsResults] = useGetWorkspaceLazyQuery({
    onError: () => {
      /**/
    }
  });

  const [updateWorkspaceSettings] = useUpdateWorkspaceSettingsMutation();

  return (
    <PublishingController
      getWorkspace={getWorkspaceSettingsQuery}
      workspaceSettingsResults={workspaceSettingsResults}
      updateWorkspaceSettings={updateWorkspaceSettings}
    />
  );
};
